<div id="hotel-result-component" class="d-flex flex-xl-row flex-column justify-content-between">
  <div
    class="d-flex flex-column justify-content-between"
    style="height: auto; width: 225px; border-right: 2px solid #e0e0e0;"
    [style.width.xl]="'100%'"
    [style.maxWidth.xl]="'225px'"
  >
    <div class="w-100 d-flex align-items-center justify-content-center" style="padding-top: 30px;">
      <img
        style="width: 180px; height: 70px; aspect-ratio: 1 / 1; cursor: pointer; object-fit: contain"
        src="{{ result?.insurances[0]?.provider?.logo }}"
      />
    </div>

    <div class="d-flex flex-column justify-content-between mt-3 mb-3 align-items-center" style="gap: 0.5em; height: 45%;">
      <hr class="m-0 p-0 w-100" style="border-color: #e0e0e0; border-width: 2px;" />

      <div class="d-flex flex-column" style="gap: 10px; padding: 15px 20px;">
        <div class="d-flex flex-column mb-1">
          <span style="font-size: 12px; color: #000000; font-family: 'Rubik'; font-weight: 600;">Comparador</span>
          <p class="m-0" style="font-size: 11px; color: #000000; font-family: 'Rubik'; font-weight: 400; line-height: 1.2;">Para una mejor experiencia, te recomendamos seleccionar hasta 3 productos.</p>
        </div>

        <div class="d-flex align-items-center" style="gap: 12px;">
          <label
            class="mb-0"
            style="
              border-radius: 6px;
              width: fit-content;
              height: 22px;
              width: 22px;
              padding-left: 1px;
              padding-top: 0.7px;
            "
            [ngStyle]="{ border: '1px solid ' + stylePathPrice?.card_line }"
          >
            <input
              type="checkbox"
              class="black-checkbox"
              (change)="toggleInsuranceSelection(result.insurances, 'compare')"
              [checked]="isInsuranceSelected(result.insurances)"
              [attr.data-insurances]="result.insurances | json"
            />
          </label>

          <button
            type="button"
            (click)="comparePlans(true)"
            [ngStyle]="{ border: '1px solid ' + stylePathPrice?.card_line }"
            class="badge rounded-pill px-4"
            style="background-color: transparent; height: 30px; font-size: 12px !important; font-weight: 700; padding: 0px 20px !important; font-family: 'Rubik';"
          >
            COMPARAR {{ getSelectedInsuranceCount() > 0 ? "(" + getSelectedInsuranceCount() + ")" : "" }}
          </button>
        </div>

      </div>
    </div>
  </div>

  <div class="d-flex flex-column container-detalles justify-content-between" style="position: relative; padding-bottom: 10px; overflow: unset;">
    <!-- pb-3 px-3 pt-2 -->
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column pb-2 pt-5 ml-4">
        <p #titlePlanSelected class="title ml-2" style="margin-bottom: 2px">{{ result?.insurances[0].plan.planName }}</p>
        <p class="mb-0 ml-2" style="font-family: &quot;Poppins&quot;, serif; font-size: 12px; font-weight: 400 !important">
          El plan contempla las siguientes coberturas
        </p>
      </div>
    </div>

    <div
      class="d-flex pr-3 pt-2 pb-2 pl-3"
      style="position: absolute; right: 0; top: 0; border-bottom: 1.5px dotted #e0e0e0; border-left: 1.5px dotted #e0e0e0; padding-left: 7px; border-bottom-left-radius: 20px;"
    >
      <button type="button" class="px-0" style="border: none; background-color: transparent">
        <img
          width="28px"
          height="28px"
          src="../../../../../assets/icons/search-result/comentario.svg"
          tooltip="Comentarios"
          (click)="openModal(ModalRooms, 'comments')"
          placement="bottom"
          alt=""
        />
      </button>
      <button type="button" clas="px-0" style="margin-right: 5px; border: none; background-color: transparent">
        <img
          width="28px"
          height="28px"
          src="../../../../../assets/icons/search-result/elearning.svg"
          tooltip="Learner"
          placement="bottom"
          alt=""
        />
      </button>
      <div class="d-flex content-icons mt-1 px-1">
        <div class="d-flex font-view px-3" style="border-left: 1px solid #bbbbbb; border-right: 1px solid #bbbbbb">
          <img
            width="28px"
            height="28px"
            src="../../../../../assets/icons/search-result/view.svg"
            class="m-0 mr-1"
            style="line-height: 1"
          />
          <p class="d-flex mb-0 flex-column justify-content-center" style="font-family: &quot;Rubik&quot;; text-transform: lowercase">
            <span style="line-height: 0.5">{{ view_insurance }}</span>
            <span style="line-height: 1.07">views</span>
          </p>
        </div>
      </div>
      <div class="d-flex content-icons px-1" (click)="openVideoModal(result.insurances[0].provider.commercial_video_link)">
        <!-- result.video_ecomerce -->
        <img
          width="28px"
          height="28px"
          src="../../../../../assets/icons/search-result/video.svg"
          class="custom-tooltip"
          style="cursor: pointer"
          [ngStyle]="{ opacity: result.insurances[0].provider.commercial_video_link === null ? '.5' : '1' }"
          tooltip="{{
            result.insurances[0].provider.commercial_video_link === null ? 'Este producto no tiene video comercial' : 'Video comercial'
          }}"
          tooltip="Video comercial"
          placement="bottom"
        />
      </div>
      <div
        class="d-flex content-icons px-1"
        style="align-items: center; margin-top: 2px"
        (click)="openVideoModal(result.insurances[0].provider.institutional_video_link)"
      >
        <!-- result.video_institut -->
        <img
          width="28px"
          height="28px"
          src="../../../../../assets/icons/search-result/video_inst.svg"
          class="custom-tooltip"
          tooltip="Video institucional"
          placement="bottom"
          [ngStyle]="{ opacity: result.insurances[0].provider.institutional_video_link === null ? '.5' : '1' }"
          tooltip="{{
            result.insurances[0].provider.institutional_video_link === null
              ? 'Este producto no tiene video institucional'
              : 'Video institucional'
          }}"
          style="cursor: pointer"
        />
      </div>
    </div>

    <div class="d-flex flex-column mx-3 mt-3">
      <div class="d-flex pb-3 justify-content-between">
        <ng-container *ngFor="let coverage of result?.insurances[0]?.plan?.coverage?.coverageList; let i = index">
          <ng-container *ngIf="i < 5">
            <div
              class="d-flex flex-column justify-content-between align-items-center"
              style="width: 20%; max-width: 20%; position: relative; margin: 0px 2px;"
            >
              <div *ngIf="coverage.icon" class="mb-3 coverage-icon" [style.background-color]="stylePathPrice?.card_background_price || '#d8d8d8'" style="padding: 8px;">
                <img #icons id="icons" [src]="coverage.icon" tooltip="{{ coverage.type }}" style="width: 21px; filter: none !important;" placement="bottom" />
              </div>

              <div class="d-flex flex-column justify-content-between h-100">
              <label tooltip="{{ coverage.type || coverage.name | capitalize }}" placement="bottom">
                <p
                  class="mb-1"
                  style="
                    font-family: &quot;Poppins&quot;, sans-serif !important;
                    font-size: 12px !important;
                    font-weight: 600;
                    text-align: center;
                    line-height: 1.2;
                  "
                >
                  {{ (coverage._slotName || coverage.name || coverage?.type | capitalize) }}
                </p>
              </label>
              <!-- <div
                style="
                  font-family: &quot;Poppins&quot;, sans-serif !important;
                  font-size: 11px !important;
                  font-weight: 500;
                "
              >
                {{ currencyAgency?.code }}
              </div> -->
              <ng-container *ngIf="coverage?.isIncluded === true">
                  <span
                    style="
                     text-align: center;
                      font-family: &quot;Poppins&quot;, sans-serif !important;
                      font-size: 11px !important;
                      font-weight: 400;
                      color: #000000;
                      border-bottom: 1px solid #bbbbbb;
                      padding-bottom: 2px;
                    "
                  >
                    {{ coverage?.coverage }}
                  </span>
              </ng-container>
              <ng-container *ngIf="coverage?.isIncluded === false">
                <select
                  #coverageSelect
                  (change)="selectCoverage($event.target.value)"
                  name=""
                  id=""
                  class="pl-2"
                  style="
                    border: none;
                    border-bottom: 1px solid #bbbbbb;
                    font-family: 'Rubik', sans-serif !important;
                    font-size: 11px !important;
                    font-weight: 400;
                    min-width: 100px !important;
                    height: 24px;
                    text-align: center;
                  "
                >
                  <ng-container *ngFor="let cover of plansValueCoverage(result?.insurances, coverage.name)">
                    <option
                      [value]="cover | json"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 11px !important;
                        font-weight: 400;
                        color: #bbbbbb;
                      "
                    >
                      <span *ngIf="coverageString(cover.coverage)">
                        {{ cover.coverage }}
                      </span>
                      <span *ngIf="!coverageString(cover.coverage) && cover.coverage > 0">
                      {{result?.insurances[0].plan?.pricing?.currency}} {{
                          cover.coverage
                        }}
                      </span>
                    </option>
                  </ng-container>
                </select>
              </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div *ngIf="result?.insurances[0].plan?.upgrades.length > 0" class="d-flex flex-column align-items-start px-2 pt-3 ml-3 mr-3" style="gap: 5px; border-radius: 6px; background-color: #f5f5f5" >
      <div class="ml-3" style="background-color: #FFFFFF; padding: 0px 10px; border-radius: 4px;">
        <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 11.21px; font-weight: 500">Adicionales</p>
      </div>

      <div class="d-flex" style="height: 110px">
        <!-- Renderiza siempre 5 slots: reales o placeholders -->
        <ng-container *ngFor="let slot of getAddonSlots(); trackBy: trackByAddonName; let i = index">
          <div *ngIf="slot" style="position: relative">
            <div class="addon-item">
              <label tooltip="{{ slot?.description || slot?.name || slot?.description }}" placement="bottom" style="max-width: 112px">
                <div class="addon-name-wrapper mb-0">
                  <p class="addon-name mb-0" style="text-align: center; padding: 0px 10px;">{{ slot?.name || slot?.description }}</p>
                </div>
              </label>

              <select
                #coverageSelect
                (change)="selectAddon(slot, $event.target.value)"
                name=""
                id=""
                class="pl-2"
                style="
                  border: none;
                  border-bottom: 1px solid #bbbbbb;
                  font-family: sans-serif !important;
                  font-size: 11px !important;
                  font-weight: 400;
                  width: 105px !important;
                  height: 24px;
                  background-color: #f5f5f5;
                  text-align: center;
                "
              >
                <!-- Formato nuevo (agrupado por name_upgrade): muestra coverage_upgrade como opción -->
                <ng-container *ngIf="slot?._grouped">
                    <option
                      *ngFor="let cov of slot.coverage_upgrade_list; let indexAddons = index"
                      [value]="indexAddons"
                      class="d-flex flex-column align-items-center justify-content-center"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 10px !important;
                        font-weight: 400;
                        color: #bbbbbb;
                      "
                    >
                      {{ cov }}
                    </option>
                  </ng-container>
                <!-- Formato viejo (sin agrupar): muestra el cost como antes -->
                <ng-container *ngIf="!slot?._grouped">
                  <ng-container *ngFor="let cost of slot.cost; let indexAddons = index">
                    <option
                      [value]="indexAddons"
                      class="d-flex flex-column align-items-center justify-content-center"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 10px !important;
                        font-weight: 400;
                        color: #bbbbbb;
                      "
                    >
                      <span>
                        {{
                          (cost > 0 ? cost : 0) | number: "1.2-2"
                        }}
                      </span>
                    </option>
                  </ng-container>
                </ng-container>
              </select>

              <p
                class="mt-1 mb-0"
                style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; font-size: 12px; cursor: pointer; color: #3fba7a;"
                *ngIf="!getAddonsIncluded(result?.insurances, slot)"
                (click)="addAddons(result?.insurances, slot, true)"
              >
                AGREGAR +
              </p>
              <p
                class="mt-1 mb-0"
                style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; font-size: 12px; cursor: pointer; color: #000000"
                *ngIf="getAddonsIncluded(result?.insurances, slot)"
                (click)="addAddons(result?.insurances, slot, false)"
              >
                ELIMINAR -
              </p>
            </div>
          </div>

          <!-- Placeholder: addon vacío -->
          <div *ngIf="!slot" class="addon-item addon-placeholder" style="width: 120px !important; padding-top: 12px !important;">
            <div class="addon-name-wrapper mb-0" style="height: auto !important;">
              <p style="text-align: center; color: #cccccc; font-size: 10px; font-weight: 600; margin-bottom: 5px; line-height: 1.2; font-family: 'Poppins'; text-transform: uppercase;">N/A</p>
            </div>
            <div class="addon-placeholder-box" style="width: 50% !important; height: 60px !important; background-color: #ffffff !important; border: 2px solid #cccccc !important; border-radius: 10px !important; position: relative;">
              <div style="position: absolute; left: 0; right: 0; top: -9px; margin: auto; width: 3px; background-color: #cccccc; height: 130%; rotate: 47deg;"></div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Adicionales restantes (se muestran cuando showAllAddons es true) -->
      <div
        class="d-flex flex-wrap addons-expandable"
        style="height: 110px"
        [class.expanded]="showAllAddons"
        [class.collapsed]="!showAllAddons"
      >
        <ng-container *ngFor="let addon of getAddonSlots(); trackBy: trackByAddonName; let i = index">
          <ng-container *ngIf="i >= 5 && addon">
            <div class="addon-item" style="position: relative; width: 120px;">
              <label class="mb-0" tooltip="{{ addon?.description || addon?.name || addon?.description }}" placement="bottom" style="max-width: 112px">
                <div class="addon-name-wrapper mb-0">
                  <p class="addon-name mb-0" style="text-align: center; padding: 0px 10px;">{{ addon?.name || addon?.description }}</p>
                </div>
              </label>

              <select
                #coverageSelect
                (change)="selectAddon(addon, $event.target.value)"
                name=""
                id=""
                class="pl-2"
                style="
                  margin-top: 5px;
                  border: none;
                  border-bottom: 1px solid #bbbbbb;
                  font-family: sans-serif !important;
                  font-size: 11px !important;
                  font-weight: 400;
                  width: 110px !important;
                  height: 30px;
                  background-color: #f5f5f5;
                  text-align: center;
                "
              >
                <!-- Formato nuevo (agrupado por name_upgrade): muestra coverage_upgrade como opción -->
                <ng-container *ngIf="addon?._grouped">
                    <option
                      *ngFor="let cov of addon.coverage_upgrade_list; let indexAddons = index"
                      [value]="indexAddons"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 10px !important;
                        font-weight: 400;
                        color: #bbbbbb;
                      "
                    >
                      {{ cov }}
                    </option>
                  </ng-container>
                <!-- Formato viejo (sin agrupar): muestra el cost como antes -->
                <ng-container *ngIf="!addon?._grouped">
                  <ng-container *ngFor="let cost of addon.cost; let indexAddons = index">
                    <option
                      [value]="indexAddons"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif !important;
                        font-size: 10px !important;
                        font-weight: 400;
                        color: #bbbbbb;
                      "
                    >
                      {{
                        (cost > 0 ? cost : 0) | number: "1.2-2"
                      }}
                    </option>
                  </ng-container>
                </ng-container>
              </select>

              <p
                class="mt-1 mb-0"
                style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; font-size: 12px; cursor: pointer; color: #3fba7a;"
                *ngIf="!getAddonsIncluded(result?.insurances, addon)"
                (click)="addAddons(result?.insurances, addon, true)"
              >
                AGREGAR +
              </p>
              <p
                class="mt-1 mb-0"
                style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; font-size: 12px; cursor: pointer; color: #000000"
                *ngIf="getAddonsIncluded(result?.insurances, addon)"
                (click)="addAddons(result?.insurances, addon, false)"
              >
                ELIMINAR -
              </p>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- Botón "Ver más" si hay más de 5 adicionales (slots reales, ya agrupados si aplica) -->
      <div *ngIf="getAddonRealCount() > 5" class="mt-2 d-flex align-items-center justify-content-end w-100" style="padding: 0px 20px 10px;">
        <button
          class="btn btn-link p-0"
          style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 500; text-decoration: none;"
          [ngStyle]="{ color: '#3fba7a' }"
          (click)="showAllAddons = !showAllAddons"
        >
          {{ showAllAddons ? "Ver menos" : "Ver más (" + (getAddonRealCount() - 5) + ")" }}
        </button>
      </div>
    </div>

    <div
      class="d-flex justify-content-between align-items-center mb-3 mx-3 mt-2"
      style="gap: 1em; border-radius: 6px; gap: 1em; border: 1px solid #9f9f9f"
    >
      <div class="d-flex flex-column align-items-start justify-content-center w-100 py-2 px-3" style="border-right: 1px solid #c2c2c2;">
        <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">Selección de pasajero/s</p>

        <mat-select
          placeholder="{{ paxesSelected.length > 0 ? paxesSelected.length + ' Pasajero/s' : 'Seleccionar pasajeros' }}"
          multiple
          class="center-placeholder-select"
          style="
            width: 100%;
            max-width: 180px;
            font-family: &quot;Rubik&quot;, serif;
            font-size: 12px;
            font-weight: 500;
          "
          [value]="isGroupSelectionOnly() ? (isGroupSelected() ? ['group'] : []) : paxesSelected"
          (selectionChange)="onSelectionChange($event, result?.insurances[0])"
          [panelClass]="'wide-panel'"
          [disabled]="isGroupSelectionOnly() ? (!paxesAvailability?.length && !paxesSelected?.length) : (!paxesFiltered.length && !paxesSelected?.length)"
        >
          <!-- Proveedor que discrimina precio por tipo de pasajero: opción por cada pasajero -->
          <ng-container *ngIf="!isGroupSelectionOnly()">
            <mat-option *ngFor="let pax of paxesFiltered; let i = index" [value]="pax" [disabled]="!pax.tempId">
              <!-- Deshabilitar si no tiene ID -->

              Pasajero {{ i + 1 }} (edad: {{ pax.age }} años {{ getAddons(pax, i) }})
            </mat-option>

            <!-- Mensaje si no hay paxes disponibles -->
            <mat-option *ngIf="!paxesFiltered.length" disabled> No hay pasajeros disponibles </mat-option>
          </ng-container>

          <!-- Proveedor sin discriminación por tipo de pasajero: única opción, selección todo-o-nada.
               El detalle de cada pasajero queda incorporado como descripción de la propia opción. -->
          <mat-option *ngIf="isGroupSelectionOnly()" value="group" class="group-option-multiline" [disabled]="!paxesAvailability?.length">
            Grupo completo (no discrimina por tipo de pasajero)

            <div class="d-flex flex-column mt-1">
              <small
                *ngFor="let pax of paxesAvailability; let i = index"
                style="font-family: &quot;Rubik&quot;, serif; font-size: 11px;color: #3d3c3c"
              >
                Pasajero {{ i + 1 }} (edad: {{ pax.age }} años {{ getAddons(pax, i) }})
              </small>
            </div>
          </mat-option>
        </mat-select>
      </div>

      <div
        class="d-flex flex-column align-items-center justify-content-center w-100 py-2 px-3"
        tooltip="Este plan tiene adicionales para las siguientes modalidades"
        placement="bottom"
      >
        <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">Modalidad</p>
        <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 400">
          {{ getModalityInsurance(result?.insurances[0]) }}
        </p>
      </div>
      <div class="d-flex flex-column align-items-center justify-content-center w-100 py-2" style="border-left: 1px solid #c2c2c3;
          padding-left: 10px;">
        <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">TOTAL PASAJEROS</p>

        <div class="d-flex align-items-center">
          <p class="currencyResult mb-0" style="font-size: 14px">{{ currencyAgency?.code }}</p>
          <p
            class="mb-0 ml-2"
            style="font-family: &quot;Rubik&quot;, serif; font-weight: 600"
            [ngClass]="{ priceMoney: countValueDot <= 4, 'count-dot-value': countValueDot > 4 }"
            [ngStyle]="{
              'font-size':
                result?.insurances[0].plan?.totalPriceProf
                | currencyConverterPure: result['insurances'][0]['plan']['pricing']['currency'] : currencyAgency?.code : currencies
                | dynamicFontSize: 18 : fontSizeAdjustments
            }"
            *ngIf="currencyAgency && result['insurances'][0]['plan']['pricing']['currency'] !== currencyAgency?.code"
          >
            {{
              result?.insurances[0].plan?.totalPriceProf
                | currencyConverterPure: result["insurances"][0]["plan"]["pricing"]["currency"] : currencyAgency?.code : currencies
                | number: "1.2-2"
            }}
          </p>
          <usb-tooltip-convert-amount
            class="mb-2"
            [clientsSettingAppBooking]="clientsSettingAppBooking"
            [currencyProduct]="result?.insurances[0].plan?.pricing?.currency"
            [valueProduct]="result?.insurances[0].plan?.totalPriceProf"
          >
          </usb-tooltip-convert-amount>
        </div>
      </div>
    </div>
  </div>
  <div
    class="d-flex flex-column container-price"
    [ngStyle]="{
      'background-color': stylePathPrice?.card_background_price,
      'border-color': stylePathPrice?.card_line
    }"
  >
    <div class="d-flex flex-column justify-content-between px-4 pb-3 pt-4" style="position: relative; height: 100%">
      <div style="height: 54%">
        <div
          *ngIf="result?.insurances[0]?.plan?.pricing?.promotions && result?.insurances[0]?.plan?.pricing?.promotions.length > 0"
          class="mb-4 d-flex align-items-center justify-content-center py-1"
          style="margin-left: -4px; width: 105px; background-color: white; border: 2px solid red; border-radius: 50rem"
        >
          <p class="mb-0 mr-2" style="font-family: &quot;Rubik&quot;, serif; font-size: 14px; font-weight: 700; color: red">
            {{ result?.insurances[0]?.plan?.pricing?.promotions[0].discountValue }}% OFF
          </p>
        </div>
        <div *ngIf="result?.insurances[0]?.plan?.pricing?.promotions && result?.insurances[0]?.plan?.pricing?.promotions.length === 0" style="height: 35px; width: 103px;"></div>

        <div class="d-flex flex-column">
          <div>
            <p
              class="mb-0"
              style="
                font-size: 16px;
                font-family: 'Rubik';
                line-height: 1.2;
                font-weight: 400;
                color: #666666;
              "
            >
              Desde
            </p>
          </div>
          <div>
            <p class="currencyResult">{{ currencyAgency?.code }}</p>
          </div>
          <div class="d-flex">
            <ng-container *ngIf="paxesSelected.length === 0">
              <p
                [ngClass]="{ priceMoney: countValueDot <= 4, 'count-dot-value': countValueDot > 4 }"
                [ngStyle]="{
                  'font-size':
                    result?.insurances[0].plan?.totalPriceProf
                    | currencyConverterPure: result['insurances'][0]['plan']['pricing']['currency'] : currencyAgency?.code : currencies
                    | dynamicFontSize: 23 : fontSizeAdjustments
                }"
                *ngIf="currencyAgency && result['insurances'][0]['plan']['pricing']['currency'] !== currencyAgency?.code"
              >
                {{
                  result?.insurances[0].plan?.totalPriceProf
                    | currencyConverterPure: result["insurances"][0]["plan"]["pricing"]["currency"] : currencyAgency?.code : currencies
                    | number: "1.2-2"
                }}
              </p>
              <usb-tooltip-convert-amount
                [clientsSettingAppBooking]="clientsSettingAppBooking"
                [currencyProduct]="result?.insurances[0].plan?.pricing?.currency"
                [valueProduct]="result?.insurances[0].plan?.totalPriceProf"
              >
              </usb-tooltip-convert-amount>
            </ng-container>

            <ng-container *ngIf="paxesSelected.length > 0">
              <p
                [ngClass]="{ priceMoney: countValueDot <= 4, 'count-dot-value': countValueDot > 4 }"
                [ngStyle]="{
                  'font-size':
                    getPricesTotalQuote(result?.insurances[0].plan?.totalPriceProf)
                    | currencyConverterPure: result['insurances'][0]['plan']['pricing']['currency'] : currencyAgency?.code : currencies
                    | dynamicFontSize: 23 : fontSizeAdjustments
                }"
                *ngIf="currencyAgency && result['insurances'][0]['plan']['pricing']['currency'] !== currencyAgency?.code"
              >
                {{
                  getPricesTotalQuote(result?.insurances[0].plan?.totalPriceProf)
                    | currencyConverterPure: result["insurances"][0]["plan"]["pricing"]["currency"] : currencyAgency?.code : currencies
                    | number: "1.2-2"
                }}
              </p>
              <usb-tooltip-convert-amount
                [clientsSettingAppBooking]="clientsSettingAppBooking"
                [currencyProduct]="result?.insurances[0].plan?.pricing?.currency"
                [valueProduct]="getPricesTotalQuote(result?.insurances[0].plan?.totalPriceProf)"
              >
              </usb-tooltip-convert-amount>
            </ng-container>
          </div>
          <div class="d-flex" *ngIf="result['insurances'][0]['plan']['pricing']['currency'] !== currencyAgency?.code">
            <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; height: auto; font-weight: 400; font-size: 12px !important">
              ({{ result?.insurances[0].plan?.pricing?.currency }})
              {{ getPricesTotalQuote(result?.insurances[0].plan?.totalPriceProf) | number: "1.2-2" }}
            </p>
            <div class="info-tool d-flex flex-column position-relative ml-1">
              <span class="tooltip-info shadow-md">
                <div class="d-flex justify-content-center align-items-center px-2 py-1">
                  <p class="mb-0" style="font-size: 14px; color: black">{{ userService.messageProviderAmount }}</p>
                </div>
              </span>
            </div>
          </div>
          <p
            *ngIf="paxesSelected.length === 0"
            class="mt-3"
            style="font-family: &quot;Rubik&quot;, serif; height: auto; font-weight: 500; font-size: 12px !important; color: #666666;"
          >
            Por {{isGroupSelectionOnly() ? 'grupo' : '1 pax' }}
          </p>

          <div *ngIf="paxesSelected.length > 0">
            <p
              class="mt-3 mb-0 pb-1 pr-1"
              style="
                font-family: &quot;Rubik&quot;, serif; height: auto; font-weight: 500; font-size: 12px !important; color: #666666;
                border-bottom: 1px solid #e4e4e4;
              "
            >
              {{ getQtyPlansSelected() }}
            </p>

            <!-- Toggle button (mismo estilo que base-item del carrito) -->
            <button
              class="toggle-btn-pax mt-2"
              (click)="togglePaxesExpanded()"
              type="button"
            >
              <span class="toggle-label" style="font-size: 11px !important; color: #3fba7a;">
                {{ isPaxesExpanded ? 'Ver menos' : 'Ver todos los pasajeros' }}
              </span>
              <span class="toggle-arrow-pax" [ngStyle]="{ 'color': clientsSettingAppBooking?.clients_setting_global?.color_main_1 }" [class.rotated]="!isPaxesExpanded">
                <img style="filter: brightness(0) saturate(100%) invert(58%) sepia(57%) saturate(570%) hue-rotate(96deg) brightness(92%) contrast(91%);" src="../../../../../../../../assets/img/app/little-icons/up-arrow-angle.svg" alt="" />
              </span>
            </button>

            <!-- Collapsible pax list -->
            <div class="collapsible-pax-content pt-2" [class.expanded]="isPaxesExpanded">

               <ng-container *ngIf="isGroupSelectionOnly()">
                <div class="d-flex justify-content-between align-items-center m-1">
                  <p
                    class="mb-0 pax-name"
                    style="font-family: &quot;Rubik&quot;, serif; height: auto; font-weight: 500; font-size: 11px !important; color: black;"
                    tooltip="Eliminar grupo"
                    placement="bottom"
                  >
                    Eliminar grupo
                  </p>
                   <button
                      (click)="removerPax(0)"
                      type="button"
                      class="pax-remove-btn "
                      tooltip="{{ isGroupSelectionOnly() ? 'Eliminar grupo' : 'Eliminar pasajero' }}"
                      placement="bottom"
                      style="height: 15px; display: flex; align-items: center; justify-content: center;background: transparent;border:0;cursor:pointer;align-items: center;"
                    >
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 590.1 590.1" style="margin-top: -2px; width: 12px; fill: #ee4f6c;" xml:space="preserve"> <g id="Layer_2_00000005971774910194079260000000718951608163606439_"> <path d="M415.1,175.1c-8.2-8.2-21.5-8.2-29.7,0c0,0,0,0,0,0l-90.3,90.3l-90.3-90.3c-8.2-8.2-21.5-8.2-29.7,0s-8.2,21.5,0,29.7 l90.3,90.3l-90.3,90.3c-8.2,8.2-8.2,21.5,0,29.7c8.2,8.2,21.5,8.2,29.7,0l90.3-90.3l90.3,90.3c8.2,8.2,21.5,8.2,29.7,0 s8.2-21.5,0-29.7l-90.3-90.3l90.3-90.3C423.3,196.6,423.3,183.3,415.1,175.1C415.1,175.1,415.1,175.1,415.1,175.1z"/> <path d="M503.7,86.4C388.1-28.5,201.3-27.9,86.4,87.7c-114.4,115.1-114.4,300.9,0,416C202,618.6,388.8,618,503.7,502.4 C618.1,387.3,618.1,201.5,503.7,86.4z M295.1,548.1C155.5,548.1,42,434.6,42,295.1S155.5,42,295.1,42s253.1,113.5,253.1,253.1 S434.6,548.1,295.1,548.1z"/> </g> </svg>
                </button>
                </div>
               </ng-container>


              <div *ngFor="let pax of paxesSelected; let i = index" class="pax-row m-1">
                <p
                  class="mb-0 pax-name"
                  style="font-family: &quot;Rubik&quot;, serif; height: auto; font-weight: 500; font-size: 11px !important; color: #666666;"
                  tooltip="{{ pax.insurance.plan.planName }}"
                  placement="bottom"
                >
                  Pax {{ i + 1 }} ({{ pax.age }} años)
                </p>
                <button
                  *ngIf="getPaxConditions(pax)"
                  type="button"
                  class="pax-icon-btn"
                  tooltip="{{ getValueConditions(pax) }}"
                  placement="bottom"
                >
                  <img src="../../../../../../../../assets/icons/admi_01.svg" width="12px" alt="">
                </button>

                <ng-container *ngIf="!isGroupSelectionOnly()">
                   <button
                      (click)="removerPax(i)"
                      type="button"
                      class="pax-remove-btn"
                      tooltip="{{ isGroupSelectionOnly() ? 'Eliminar grupo' : 'Eliminar pasajero' }}"
                      placement="bottom"
                      style="height: 15px; display: flex; align-items: center; justify-content: center;"
                    >
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 590.1 590.1" style="margin-top: -2px; width: 12px; fill: #ee4f6c;" xml:space="preserve"> <g id="Layer_2_00000005971774910194079260000000718951608163606439_"> <path d="M415.1,175.1c-8.2-8.2-21.5-8.2-29.7,0c0,0,0,0,0,0l-90.3,90.3l-90.3-90.3c-8.2-8.2-21.5-8.2-29.7,0s-8.2,21.5,0,29.7 l90.3,90.3l-90.3,90.3c-8.2,8.2-8.2,21.5,0,29.7c8.2,8.2,21.5,8.2,29.7,0l90.3-90.3l90.3,90.3c8.2,8.2,21.5,8.2,29.7,0 s8.2-21.5,0-29.7l-90.3-90.3l90.3-90.3C423.3,196.6,423.3,183.3,415.1,175.1C415.1,175.1,415.1,175.1,415.1,175.1z"/> <path d="M503.7,86.4C388.1-28.5,201.3-27.9,86.4,87.7c-114.4,115.1-114.4,300.9,0,416C202,618.6,388.8,618,503.7,502.4 C618.1,387.3,618.1,201.5,503.7,86.4z M295.1,548.1C155.5,548.1,42,434.6,42,295.1S155.5,42,295.1,42s253.1,113.5,253.1,253.1 S434.6,548.1,295.1,548.1z"/> </g> </svg>
                </button>

                </ng-container>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column mt-3">
        <div class="d-flex justify-content-between mb-3" style="gap: 0.25em">
          <button
            style="background-color: transparent; border: 1px solid black; border-radius: 12px; width: 65px"
            (click)="openDetail()"
          >
            <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px">Ver más</p>
          </button>

          <button
            style="background-color: transparent; border: 1px solid black; border-radius: 12px; width: 65px"
            (click)="getTermUrl(result?.insurances[0].contact?.termsUrl)"
          >
            <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px">Cond.</p>
          </button>
        </div>
        <div class="d-flex justify-content-center">
          <button
            type="button"
            class="d-flex justify-content-center align-items-center"
            class="btn btn-add"
            (click)="add(result)"
            style="border-radius: 6px"
            [ngStyle]="{
              color: stylePathPrice?.color_2,
              'background-color': clientsSettingAppBooking?.clients_setting_global?.color_main_1
            }"
          >
            {{ chargePlan ? "PROCESANDO" : "COMPRAR" }}
          </button>
        </div>

      </div>
    </div>

    <!-- Blickoins -->
       <usb-blickoins
                      [blickoins]="getBlickoins"
                      [stylePathPrice]="stylePathPrice"
       ></usb-blickoins>

  </div>
</div>
